var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-15"},[_c('v-row',[_c('v-col',{staticClass:"pt-8 mb-5",attrs:{"cols":"12","md":"4"}},[_c('Coordonnees')],1),_c('v-col',{staticClass:"pt-8 mb-5",attrs:{"cols":"12","md":"8"}},[_c('Formulaires')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }